const rendition = {
    namespaced: true,
    state: {
        savedCashDesk: [],
        savedCashDetail: [],
        savedComments: '',
        savedDate: '',
    },
    mutations: {
        STORE_DRAFT: (state, payload) => {
            Object.assign(state, payload)
        },
    },
    actions: {
        storeDraft: ({ commit }, payload) => {
            commit('STORE_DRAFT', payload)
        },
    },
}

export default rendition
